import { AjaxHelper, IPaginatedList } from '@samc/common';
import { ISurvivorshipTemplate, SurvivorshipTemplateFilter, ISurvivorshipTemplateGroup, SurvivorshipTemplateGroupFilter, ISearchParams } from '../Interfaces';

export class SurvivorshipTemplateService {
  private _helper: AjaxHelper;

  public constructor(verificationToken: string | null = null, client: string | null = null, jwt: string | null = null) {
    this._helper = new AjaxHelper('/componentapi/survivorship', verificationToken, client, jwt);
  }

  public async upsertSurvivorshipTemplate(template: ISurvivorshipTemplate): Promise<ISurvivorshipTemplate> {
    return await this._helper.putData<ISurvivorshipTemplate>('template', template);
  }

  public async searchSurvivorshipTemplate(query: Partial<SurvivorshipTemplateFilter> & Partial<ISearchParams>): Promise<IPaginatedList<ISurvivorshipTemplate>> {
    return await this._helper.getData<IPaginatedList<ISurvivorshipTemplate>>('template', query);
  }

  public async addSurvivorshipTemplateGroup(template: ISurvivorshipTemplateGroup): Promise<ISurvivorshipTemplateGroup> {
    return await this._helper.postData<ISurvivorshipTemplateGroup>('template-group', template);
  }

  public async searchSurvivorshiptTemplateGroup(query: Partial<SurvivorshipTemplateGroupFilter> & Partial<ISearchParams>): Promise<IPaginatedList<ISurvivorshipTemplateGroup>> {
    return await this._helper.getData<IPaginatedList<ISurvivorshipTemplateGroup>>('template-group', query);
  }

  public updateJwt(jwt: string | null) {
    this._helper.jwt = jwt;
  }
}